import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const validChars = /^\+?[0-9]*$/.test(control.value);
    const validPrefix = /^(\+|00)[0-9]*$/.test(control.value);
    const validLength = /^(\+|00)[0-9]{1,50}$/.test(control.value);

    let errMsg: string | null = null;
    if (!validChars) {
      errMsg = 'Nevalidné telefónne číslo, obsahuje neplatné znaky.';
    } else if (!validPrefix) {
      errMsg = 'Nevalidné telefónne číslo, musí začínať s "+" alebo "00."';
    } else if (!validLength) {
      errMsg = 'Nevalidné telefónne číslo, neplatná dĺžka.';
    }

    return errMsg && control.value ? { invalidPhoneNumber: { value: control.value, msg: errMsg } } : null;
  };
}
